// extracted by mini-css-extract-plugin
module.exports = {"info":"tweet-info_info__jqxeD","infoLink":"tweet-info_infoLink__xA344","infoIcon":"tweet-info_infoIcon__E9Qzz"};